import { render, staticRenderFns } from "./InstanceActions.vue?vue&type=template&id=ad8b8886&scoped=true&"
import script from "./InstanceActions.vue?vue&type=script&lang=js&"
export * from "./InstanceActions.vue?vue&type=script&lang=js&"
import style0 from "./InstanceActions.vue?vue&type=style&index=0&id=ad8b8886&prod&scoped=true&lang=css&"
import style1 from "./InstanceActions.vue?vue&type=style&index=1&id=ad8b8886&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8b8886",
  null
  
)

export default component.exports